import * as React from "react";
import { useNavigate } from "react-router";

/**
 * @ignore - internal component.
 */

export interface LinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  disabled?: boolean;
}

export const Link = React.forwardRef(function Link(
  props: LinkProps,
  ref: React.ForwardedRef<HTMLAnchorElement>
) {
  const { children, href, onClick, disabled, ...rest } = props;
  const navigate = useNavigate();

  const handleLinkClick = React.useMemo(() => {
    return (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      const url = new URL(event.currentTarget.href);
      navigate(url.pathname);
      onClick?.(event);
    };
  }, [onClick, navigate]);

  return disabled ? (
    children
  ) : (
    <a ref={ref} href={href} {...rest} onClick={handleLinkClick}>
      {children}
    </a>
  );
});
